export const ROLENAME_LENGTH = 50;
export const RECEIPT_NOTE_MAX_LENGTH = 500;
export const BRANCH_ALIAS_MAX_LENGTH = 50;
export const BRANCH_NAME_MAX_LENGTH = 50;
export const FACULTY_NAME_MAX_LENGTH = 50;
export const FACULTY_BANK_BARNCH_MAX_LENGTH = 50;
export const MODULE_NAME_MAX_LENGTH = 100;
export const TOPIC_NAME_MAX_LENGTH = 100;
export const PASSWORD_MIN_LENGTH = 8;

export const VALIDATION_MESSAGES = {

    //Email
    EMAIL_REQUIRED : "Email is required",
    EMAIL_VALID: "Email must be a valid email",

    //Password
    PASSWORD_REQUIRED : "Password is required",
    PASSWORD_VALID : `Password must be at least ${PASSWORD_MIN_LENGTH} characters and contain at least one letter, one number, one special character, one capital letter`,
    CONFIRM_PASSWORD_REQUIRED : "Password is required",
    CONFIRM_PASSWORD_VALID : `Password must be at least ${PASSWORD_MIN_LENGTH} characters and contain at least one letter, one number, one special character, one capital letter`,

    //Phone 
    PHONE_NUMBER_REQUIRED : "Mobile number is required",
    PHONE_VALID : "Mobile number must be a valid 10-digit number",
    PHONE_ACCESS_REQUIRED : "Mobile access information is required",

    //Name
    FIRST_NAME_REQUIRED : "first name is required",
    LAST_NAME_REQUIRED : "last name is required",
    NAME_REQUIRED : "Name is required",
    NAME_SPACE : "Name without spaces",
    ALIAS : "Alias is required",

    //Date
    DATE : "Date is required",
    BIRTH_DATE : "Birth Date is required",
    START_DATE : "Start date is required",
    START_DATE_VALID : "Start Date cannot be after End Date",
    END_DATE : "End date is required",
    APPLICABLE_DATE : "Applicable Date is required",
    FOLLOWUP_DATE : "Followup Date is required",
    INQUIRY_DATE : "Inquiry date is required",

    // Academic
    COMPLETION_YEAR_REQUIRED : "Completion year is required",
    COMPLETION_YEAR_VALID : "Completion Year must be a valid year",
    DEGREE_REQUIRED : "Degree is required",
    SCHOOL_NAME_REQUIRED : "School name is required",
    STREEM_REQUIRED : "Stream is required",
    PERCENTAGE : "Percentage must be a number between 0 and 100",
    PERCENTAGE_SPACE : "No leading or trailing spaces allowed",
    PERCENTAGE_DECIMAL : "Percentage must be a valid number with up to two decimal places",
    MIN_PERCENTAGE : "Percentage cannot be less than 0",
    MAX_PERCENTAGE : "Percentage cannot be more than 100",
    CLASS_NUMBER : 'Class Number is required',
    CLASS_NAME : 'Class Name is required',
    CLASS_ROOM_REQUIRED : "'Classroom is required'",
    MCQ_REQUIRED : "Mcq is required",
    DESCRIPTIVE_REQUIRED : "descriptive is required",

    // WorkExperiences
    MIN_YEAR : "Year cannot be less than 0",
    MIN_MONTH : "Month cannot be less than 0",
    MAX_MONTH : "Month cannot be more than 11",

    // ADDRESS
    STATE_REQUIRED : "State is required",
    CITY_REQUIRED : "City is required",
    AREA_REQUIRED : "Area is required",
    FULL_ADDRESS_REQUIRED : "Full Address is required",

    // COURSE
    COURSE_REQUIRED : "Course is require",
    BATCH_REQUIRED : "Batch is required",
    BRANCH_REQUIRED : "Branch is required",
    COURSE_EXPECTATION_REQUIRED :  "Course Expectation is required",
    COURSE_FEES_REQUIRED : "Course Fees is required",
    TOTAL_FEES_REQUIRED : "Total Fees is required",
    FEE_STRUCTURE : "Fees Structure is required",
    MODULE_NAME_REQUIRED : 'Module name is required',
    TOPIC_NAME_REQUIRED : 'Topic name is required',
    REGISTRATION_AMOUNT : 'Registration Amount is required',

    // BANK 
    BANK_NAME_REQUIRED : "Bank is required",
    BANK_ACCOUNT_NUMBER_REQUIRED : "Account Number is required",
    BANK_ACCOUNT_NUMBER_VALID : "Account Number is invalid",   
    BANK_IFSC_CODE_REQUIRED : "IFSC Code is required",
    BANK_IFSC_CODE_VALID : "Invalid IFSC Code",
    BANK_BRANCH_REQUIRED : "Bank Branch is required",

    PRIORITY_REQUIRED : "Priority is required",
    QUANTITY_REQUIRED : "Quantity is required",
    FACULTY_REQUIRED : "'Faculty is required'",
    ROLE : "User role is required",
    INVENTORY_NAME_REQUIRED : "Inventory Name is required",

    INQUIRY_SOURCE : 'Inquiry source is required',

    EDUCATION_QUALIFICATION:"Education qualification is required",

    AREA_NAME_REQUIRED:"Area name is required",
    
    ONE_SHOT_PAY_REQUIRE : "One Shot Pay is required",
    ONE_SHOT_PAY_VALID : "One Shot Pay must be a number",
    INSTALLMENT_PAY_REQUIRE : "Installment Pay is required",
    INTALLMENT_PAY_VALID : "Installment Pay must be a number",

    //LENGTH VALIDATION
    ROLENAME_LENGTH_VALIDATION : `Role Name must be less than ${ROLENAME_LENGTH} characters`,
    MODULE_NAME_LENGTH_VALIDATION : `Module name cannot exceed ${MODULE_NAME_MAX_LENGTH} characters`,
    TOPIC_NAME_LENGTH_VALIDATION : `Topic name cannot exceed ${TOPIC_NAME_MAX_LENGTH} characters`,

    ENROLLMENT_FORM : {
        ENROLLMENT_DATE : "Enrollment Date is required",
        FATHER_NAME : "Father name is required",
        MOTHER_NAME : "Mother name is required",
        STUDENT_CODE : "Student code is required",
        STUDENT_NAME : "Student name is required",
        STUDENT_EMAIL_REQUIRED : "Student email is required",
        STUDENT_EMAIL_VALID : "Student email is invalid",
        STUDENT_PHONE_VALID : "Student mobile number is invalid",
        STUDENT_PHONE_REQUIRED : "Student mobile number is required",
        STUDENT_BIRTH_DATE_REQUIRED : "Student Birth date is required",
        PARENT_PHONE_VALID : "Parent mobile number is invalid",
        PARENT_PHONE_REQUIRED : "Parent mobile number is required",
    },

    BRANCH_FORM : {
        BRANCH_NAME_REQUIRED : "Branch name is required",
        BATCH_REQUIRED : "Batch is required",
        BRANCH_NAME_SPACE : "Branch name without spaces",
        BRANCH_NAME_MAX : `Branch Name must be less than ${BRANCH_NAME_MAX_LENGTH} characters`,
        BRANCH_PHONE_VALID : "Branch mobile number is invalid",
        BRANCH_PHONE_REQUIRED : "Branch mobile number is required",
        USER_PHONE_VALID : "User mobile number is invalid",
        USER_PHONE_REQUIRED : "User mobile number is required",
        BRANCH_EMAIL_REQUIRED : "Branch email is required",
        BRANCH_EMAIL_VALID : "Branch email is invalid",
        BRANCH_FULL_ADDRESS : "Branch Full address is required",
        BRANCH_STATE : "Branch state is required",
        BRANCH_CITY : "Branch city is required",
        BRANCH_AREA : "Branch area is required",
        RECEIPT_NOTE_REQUIRED : "Receipt is required",
        RECEIPT_NOTE_MAX : `Receipt Note must be less than ${RECEIPT_NOTE_MAX_LENGTH} characters`,
        BRANCH_ALIAS_REQUIRED : "Branch alias is required",
        BRANCH_ALIAS_MAX : `Branch Alias must be less than ${BRANCH_ALIAS_MAX_LENGTH} characters`,
        USER_FIRST_NAME : "User first name is required",
        USER_LAST_NAME : "User last name is required",
        USER_EMAIL_REQUIRED : "User email is required",
        USER_EMAIL_VALID : "User email is invalid",
    },

    FACULTY_FORM : {
        FACULTY_NAME_REQUIRED : "Faculty name is required",
        FACULTY_NAME_MAX : `Faculty Name must be less than ${FACULTY_NAME_MAX_LENGTH} characters`,
        FACULTY_PHONE_NUMBER_REQUIRED : "Faculty mobile number is required",
        FACULTY_PHONE_NUMBER_VALID : "Faculty mobile number is invalid",
        FACULTY_EMAIL_REQUIRED: "Faculty email is required",
        FACULTY_EMAIL_VALID : "Faculty email is invalid",
        FACULTY_STATE : "Faculty state is required",
        FACULTY_CITY : "Faculty city is required",
        FACULTY_AREA : "Faculty area is required",
        FACULTY_HOURLY_RATE_REQUIRED : "Hourly Rate is required",
        FACULTY_BANK_BARNCH_MAX : `Bank Branch must be less than ${FACULTY_BANK_BARNCH_MAX_LENGTH} characters`,
        FACULTY_FULL_ADDRESS : "Faculty Full Address is required",
    }
}